import { NgModule } from '@angular/core';

import { FuseIfOnDomDirective } from '@fuse/directives/fuse-if-on-dom/fuse-if-on-dom.directive';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { FuseMatSidenavHelperDirective, FuseMatSidenavTogglerDirective } from '@fuse/directives/fuse-mat-sidenav/fuse-mat-sidenav.directive';
import { DisabledControlDirective } from './disabled-control/disabled-control.directive';
import { DecimalLimitDirective } from './decimal-limit.directive';

@NgModule({
  declarations: [
    FuseIfOnDomDirective,
    FuseMatSidenavHelperDirective,
    FuseMatSidenavTogglerDirective,
    FusePerfectScrollbarDirective,
    DisabledControlDirective,
    DecimalLimitDirective
  ],
  imports: [],
  exports: [
    FuseIfOnDomDirective,
    FuseMatSidenavHelperDirective,
    FuseMatSidenavTogglerDirective,
    FusePerfectScrollbarDirective,
    DisabledControlDirective,
    DecimalLimitDirective
  ]
})
export class FuseDirectivesModule {}
